<template>
    <div class="fluid page_content" v-if="permission && permission.version === '5'">

      <div class="page_heading">
        <div class="col-5 module_heading" role="heading" aria-level="1">
          <span class="program_guide_icon icon-list"></span>
          <span class="program_guide_title">Assign Associated Institutions with {{institution.title}}</span>
        </div>

        <div class="col-7 btn_container pagination_sty3">
        </div>
      </div>

		<div class="user-management-section">
      <div class="page_subheading">
        <!-- Search Bar -->
        <div class="col-5" style="padding-left: 0px;">
          <div class="search_field advisor-search-section">
            <input placeholder="search by name" aria-label="search by name" v-model="searchTitle" v-on:keyup.enter="search">
            <div class="clear-btn" v-if="this.searchTitle.length > 0" @click="search">
                <b-btn @click="searchTitle = ''" aria-label="clear">X</b-btn>
            </div>
            <b-btn class="left" @click="search"><span class="fas fa-search" aria-label="search program guides"></span></b-btn>
          </div>
        </div>
        <!-- Page Buttons -->
        <div class="col-7 btn_container pagination_sty3">
          <button type="button" :disabled="this.firstPage" @click="prev" class="btn btn_trans" :title="$t('previousPage')" :aria-label="$t('previousPage')"><span class="ic2_arr_pre3" aria-hidden="true"></span></button>
          <span class="page_count" aria-hidden="true">{{ page + 1  }}</span>
          <select v-model="pageSize" @change="resetPage" aria-label="page size" class="page_size">
            <option v-for="option in sizeOptions" v-bind:value="option">
              {{ option }}
            </option>
          </select>
        
          <button type="button" :disabled="this.lastPage" @click="next" class="btn btn_trans" :title="$t('nextPage')" :aria-label="$t('nextPage')"><span class="ic2_arr_next3" aria-hidden="true"></span></button></div>
      </div>

			<div class="table_containers">
        <div class="row programs_list">
          <div class="col-12">

            <div class="row">
              <div class="col-12 program" v-for="inst in institutions" v-if="inst.uuid !== institution.uuid">
                <input type="checkbox" :id="inst.uuid" :value="inst.uuid" v-model="associatedInstitutions">
                <label :for="inst.uuid">{{inst.title}}</label>
              </div>
            </div>

          </div>
        </div>
			</div>
		</div>
    <div class="loading-spinner">
      <b-modal style="padding: 0px;" ref="loadingModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
          <div class="text-center" style="color: #FFF">
              <i class="fa fa-spinner fa-spin" style="font-size: 50px"></i>
          </div>
      </b-modal>
    </div>

    </div>
</template>

<script>
import '../../../assets/module/css/user/userList.min.css'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'assignAssociatedInstitutions',
  props: ['uuid'],
  data () {
    return {
      pageSize: 10,
      sizeOptions: [ 10, 50, 100 ],
      firstPage: true,
      lastPage: true,
      page: 0,
      totalPages: 0,
      totalElements: 0,
      institutions: [],
      isInstitutionsLoaded: false,
      institutionDeleteMessage: '',
      institutionToBeDeleted: {},
      searchTitle: '',
      associatedInstitutions: []
    }
  },

  mounted () {
    this.loadPermission().then(res => {
      this.$refs.loadingModal.show()
      setTimeout(() => {
        this.loadInstitutionList()
      }, 500)
    })
  },
  methods: {
    ...mapActions([
      'searchInstitutions',
      'deleteInstitution',
      'loadPermission',
      'storeInstitution',
      'loadInstitutionDetail'
    ]),
    async loadInstitutionList () {
      this.searchInstitutions({page: this.page, count: this.pageSize, title: this.searchTitle}).then(result => {
        this.institutions = result.content
        this.page = result.number
        // latest Spring library changed Page.java fields from firstPage -> first and lastPage -> last
        this.firstPage = (result.first || result.firstPage) ? (result.first || result.firstPage) : false
        this.lastPage = (result.last || result.lastPage) ? (result.last || result.lastPage) : false
        this.totalPages = result.totalPages
        this.totalElements = result.totalElements
        this.isInstitutionsLoaded = true
        this.$refs.loadingModal.hide()
      })
      await this.loadInstitutionDetail(this.uuid)
      console.log('aI:', this.institution.associatedInstitutions)
      this.associatedInstitutions = this.institution.associatedInstitutions
    },
    resetPage () {
      this.page = 0
      this.loadInstitutionList()
    },
    prev () {
      this.page = this.page - 1
      this.loadInstitutionList()
    },
    next () {
      this.page = this.page + 1
      this.loadInstitutionList()
    },
    search () {
      this.page = 0
      this.firstPage = true
      this.lastPage = true
      this.totalPages = 0
      this.totalElements = 0
      this.loadInstitutionList()
    },
    async updateInstitutionDetail () {
      let institutionData = _.cloneDeep(this.institution)
      institutionData.associatedInstitutions = _.cloneDeep(this.associatedInstitutions)
      this.storeInstitution(institutionData)
    }
  },
  computed: {
    ...mapState({
      'permission': state => state.user.permission,
      'institution': state => state.institution.institution
    }),

    createInsitutionButtonEnabled () {
      let permission = this.permission
      let institutionPermission = permission.institutionPermission
      return institutionPermission && institutionPermission.create
    }
  },
  watch: {
    associatedInstitutions (newAssociatedInstitutions) {
      this.updateInstitutionDetail()
    }
  }
}
</script>

<style scoped>
.program_guide_icon {
  float:left;
  width:30px;
  font-size:30px;
  color:#34b2ff;
  margin:3px 3px 0 0 !important;
}

.program_guide_title {
  color: #34b2ff;
  font-size: 22px;
  font-weight: 400;
  float: left;
  margin-top: 4px;
}
</style>



// WEBPACK FOOTER //
// src/app/institution/components/AssignAssociatedInstitution.vue